module.exports = __webpack_public_path__ + "img/4-3.f97f9afb.svg";